import React, { useEffect, useState, useRef } from 'react';
import { Dashboard } from './components/Dashboard';
import { Navigation } from './components/Navigation';
import { Breadcrumbs, BreadcrumbItem } from './components/Breadcrumbs';
import { getAvailableLocales } from './components/utils/currencyFormatter';
import { VendorManagement } from './components/vendor/VendorManagement';
import { APManagement } from './components/ap/APManagement';
import { CreditNoteManagement } from './components/credit-notes/CreditNoteManagement';
import { EntityManagement } from './components/settings/EntityManagement';
import { UserManagement } from './components/settings/UserManagement';
import { LicenseManager } from './components/settings/LicenseManager';
import { ChartOfAccounts } from './components/financial/ChartOfAccounts';
import { LedgerView } from './components/financial/LedgerView';
import { CurrencyExchangeView } from './components/financial/CurrencyExchangeView';
import { ReceiptingView } from './components/procurement/ReceiptingView';
import { ProcurementDashboard } from './components/procurement/ProcurementDashboard';
import { DelegationsManager } from './components/financial/DelegationsManager';
import { RulesWorkflowManager } from './components/financial/RulesWorkflowManager';
import { RulesManager } from './components/financial/RulesManager';
import { WorkflowManager } from './components/financial/workflows/WorkflowManager';
import { CatalogsManagement } from './components/procurement/CatalogsManagement';
import { BudgetManagement } from './components/financial/budget/BudgetManagement';
import { TaxCodesManagement } from './components/financial/tax/TaxCodesManagement';
import { RoundingConfiguration } from './components/financial/rounding/RoundingConfiguration';
import { ToleranceConfiguration } from './components/financial/tolerance/ToleranceConfiguration';
import { TagsManagement } from './components/settings/tags/TagsManagement';
import { NotesManagement } from './components/settings/notes/NotesManagement';
import { AuditManagement } from './components/settings/audit/AuditManagement';
import { CountriesManagement } from './components/settings/countries/CountriesManagement';
import { CurrencyManagement } from './components/settings/currency/CurrencyManagement';
import { EmailConfiguration } from './components/settings/email/EmailConfiguration';
import { ReportsOverview } from './components/reports/ReportsOverview';
import { ReportViewer } from './components/reports/ReportViewer';
import { RequisitionForm } from './components/procurement/RequisitionForm';
import { PurchaseOrderForm } from './components/procurement/PurchaseOrderForm';
import { PurchaseOrderList } from './components/procurement/PurchaseOrderList';
import { RequisitionList } from './components/procurement/RequisitionList';
import { reportCategories } from './components/reports/ReportsOverview';
import { PaymentsView } from './components/financial/payments/PaymentsView';
import { ChevronDownIcon, LogOutIcon, GlobeIcon, UserIcon } from 'lucide-react';
import { DIValidation } from './components/di/DIValidation';
import { DIExceptions } from './components/di/DIExceptions';
import { DIExceptionHandling } from './components/di/DIExceptionHandling';
import { DITraining } from './components/di/DITraining';
import { DocumentLibrary } from './components/di/DocumentLibrary';
import { FileLibrary } from './components/di/FileLibrary';
import { TasksManagement } from './components/di/TasksManagement';
import { MessagesManagement } from './components/settings/messages/MessagesManagement';
import { NotificationsManagement } from './components/settings/notifications/NotificationsManagement';
import { ExpenseManagement } from './components/expense/ExpenseManagement';
import { ContractManagement } from './components/contracts/ContractManagement';
import { RCTIManagement } from './components/rcti/RCTIManagement';
import { DecimalPrecisionConfiguration } from './components/settings/decimal/DecimalPrecisionConfiguration';
import { AuthScreen } from './components/AuthScreen/AuthScreen';
import { CommunicationsView } from './components/financial/communications/CommunicationsView';
import { StatusManagement } from './components/settings/status/StatusManagement';
import { HomeIcon, FileTextIcon, UsersIcon, ShoppingCartIcon, ReceiptIcon, SettingsIcon, DollarSignIcon, FileBarChart2Icon, FileSignatureIcon, CreditCardIcon, BookIcon, BookOpenIcon, BuildingIcon, MailIcon, CoinsIcon, KeyIcon, TagIcon, MessageSquareIcon, ClipboardListIcon, CheckSquareIcon, AlertTriangleIcon, BarChartIcon, TruckIcon, DatabaseIcon, MinusSquareIcon, ChevronLeftIcon, FilterIcon, ClockIcon, RefreshCwIcon, FolderIcon, CheckIcon } from 'lucide-react';
import { ConstructionPaymentReport } from './components/reports/construction/ConstructionPaymentReport';
import { OperationalAnalyticsReport } from './components/reports/operational/OperationalAnalyticsReport';
import { InvoiceAgingReport } from './components/reports/ap/InvoiceAgingReport';
import { InvoicePaymentStatusReport } from './components/reports/ap/InvoicePaymentStatusReport';
import { PurchaseOrderSummary } from './components/reports/procurement/PurchaseOrderSummary';
import { BudgetVsActualReport } from './components/reports/financial/BudgetVsActualReport';
import { RequisitionSummaryReport } from './components/reports/requisition/RequisitionSummaryReport';
import { ReceiptList } from './components/procurement/ReceiptList';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentView, setCurrentView] = useState('dashboard');
  const [selectedRequisition, setSelectedRequisition] = useState(null);
  const [selectedPOForReceipt, setSelectedPOForReceipt] = useState(null);
  const [locale, setLocale] = useState('en-AU');
  const [selectedReport, setSelectedReport] = useState(null);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const profileMenuRef = useRef(null);
  const profileButtonRef = useRef(null);
  const [requisitions, setRequisitions] = useState([{
    id: 'REQ-2023-001',
    name: 'Office Supplies',
    vendor: 'Office Depot',
    status: 'Draft',
    date: '2023-10-15',
    total: 1250.75
  }, {
    id: 'REQ-2023-002',
    name: 'IT Equipment',
    vendor: 'Dell Technologies',
    status: 'Pending Approval',
    date: '2023-10-12',
    total: 5430.0
  }, {
    id: 'REQ-2023-003',
    name: 'Marketing Materials',
    vendor: 'PrintWorks Inc.',
    status: 'Approved',
    date: '2023-10-05',
    total: 3200.5
  }]);
  const [purchaseOrders, setPurchaseOrders] = useState([{
    id: 'PO-2023-001',
    name: 'Server Hardware',
    vendor: 'Server Solutions Inc.',
    status: 'Sent to Vendor',
    date: '2023-10-10',
    total: 12500.0,
    requisitionId: null // Direct PO, not from requisition
  }, {
    id: 'PO-2023-002',
    name: 'Marketing Materials',
    vendor: 'PrintWorks Inc.',
    status: 'Pending Confirmation',
    date: '2023-10-06',
    total: 3200.5,
    requisitionId: 'REQ-2023-003' // Created from requisition
  }]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const getBreadcrumbs = () => {
    const breadcrumbs: BreadcrumbItem[] = [];
    // Always start with home
    breadcrumbs.push({
      label: 'Dashboard',
      view: 'dashboard',
      icon: HomeIcon
    });
    // Add additional breadcrumbs based on currentView
    if (currentView === 'vendor-management' || currentView === 'vendors') {
      breadcrumbs.push({
        label: 'Vendor Management',
        view: currentView,
        icon: UsersIcon
      });
    } else if (currentView === 'onboard-vendor') {
      breadcrumbs.push({
        label: 'Vendor Management',
        view: 'vendor-management',
        icon: UsersIcon
      });
      breadcrumbs.push({
        label: 'Add New Vendor',
        view: currentView,
        icon: UserIcon
      });
    } else if (currentView.startsWith('reports-')) {
      breadcrumbs.push({
        label: 'Reports',
        view: 'reports',
        icon: FileBarChart2Icon
      });
      if (selectedReport) {
        breadcrumbs.push({
          label: selectedReport.name,
          view: currentView,
          icon: FileTextIcon
        });
      }
    } else if (currentView === 'create-requisition') {
      breadcrumbs.push({
        label: 'Procurement',
        view: 'procurement-dashboard',
        icon: ShoppingCartIcon
      });
      breadcrumbs.push({
        label: 'Create Requisition',
        view: currentView,
        icon: FileTextIcon
      });
    } else if (currentView === 'create-po') {
      breadcrumbs.push({
        label: 'Procurement',
        view: 'procurement-dashboard',
        icon: ShoppingCartIcon
      });
      breadcrumbs.push({
        label: 'Create Purchase Order',
        view: currentView,
        icon: FileTextIcon
      });
    } else if (currentView === 'requisitions') {
      breadcrumbs.push({
        label: 'Procurement',
        view: 'procurement-dashboard',
        icon: ShoppingCartIcon
      });
      breadcrumbs.push({
        label: 'Requisitions',
        view: currentView,
        icon: ClipboardListIcon
      });
    } else if (currentView === 'purchase-orders') {
      breadcrumbs.push({
        label: 'Procurement',
        view: 'procurement-dashboard',
        icon: ShoppingCartIcon
      });
      breadcrumbs.push({
        label: 'Purchase Orders',
        view: currentView,
        icon: ClipboardListIcon
      });
    } else if (currentView === 'receipting') {
      breadcrumbs.push({
        label: 'Procurement',
        view: 'procurement-dashboard',
        icon: ShoppingCartIcon
      });
      breadcrumbs.push({
        label: 'Goods Receipt',
        view: currentView,
        icon: TruckIcon
      });
    } else if (currentView === 'receipt-list') {
      breadcrumbs.push({
        label: 'Procurement',
        view: 'procurement-dashboard',
        icon: ShoppingCartIcon
      });
      breadcrumbs.push({
        label: 'Goods Receipts',
        view: currentView,
        icon: ClipboardListIcon
      });
    } else if (currentView === 'document-library') {
      breadcrumbs.push({
        label: 'Document Intelligence',
        view: 'di-validation',
        icon: FileTextIcon
      });
      breadcrumbs.push({
        label: 'Document Library',
        view: currentView,
        icon: FileTextIcon
      });
    } else if (currentView === 'file-library') {
      breadcrumbs.push({
        label: 'Document Intelligence',
        view: 'di-validation',
        icon: FileTextIcon
      });
      breadcrumbs.push({
        label: 'File Library',
        view: currentView,
        icon: FolderIcon
      });
    } else if (currentView === 'tasks') {
      breadcrumbs.push({
        label: 'Document Intelligence',
        view: 'di-validation',
        icon: FileTextIcon
      });
      breadcrumbs.push({
        label: 'Tasks',
        view: currentView,
        icon: CheckIcon
      });
    }
    return breadcrumbs;
  };
  const isExpenseView = ['expense-management', 'expense-claims', 'expense-claim-detail', 'add-expense-claim', 'expense-approval', 'expense-reports'].includes(currentView);
  const isContractView = ['contract-management', 'contracts', 'onboard-contract', 'contract-details', 'add-contract', 'contract-detail', 'contract-variations', 'contract-amendments', 'contract-milestones', 'contract-payment-claims', 'contract-types'].includes(currentView);
  const isCreditNoteView = ['credit-note-dashboard', 'credit-note-entry', 'credit-note-list', 'credit-note-details'].includes(currentView);
  const isProcurementView = ['create-requisition', 'create-po', 'requisitions', 'purchase-orders', 'receipt-list', 'procurement-dashboard', 'catalogs'].includes(currentView);
  const isCommunicationsView = ['communications'].includes(currentView);
  const isSettingsView = ['settings', 'users', 'license-manager', 'tags', 'notes', 'audit', 'rules-workflows', 'countries', 'currency', 'email-configuration', 'messages', 'notifications', 'decimal-precision', 'status-management'].includes(currentView);
  const isReportsView = ['reports', 'reports-procurement', 'reports-ap', 'reports-requisition', 'reports-financial', 'reports-operational', 'reports-construction'].includes(currentView);
  useEffect(() => {
    const handleClickOutside = event => {
      if (profileMenuOpen && !profileButtonRef.current?.contains(event.target) && !profileMenuRef.current?.contains(event.target)) {
        setProfileMenuOpen(false);
      }
    };
    if (profileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [profileMenuOpen]);
  useEffect(() => {
    window.setSelectedReport = reportData => {
      console.log('Setting report via global function:', reportData);
      setSelectedReport({
        ...reportData,
        _timestamp: Date.now()
      });
    };
    if (currentView.startsWith('reports-') && !selectedReport) {
      const reportType = currentView.split('-')[1];
      const category = reportCategories.find(cat => cat.id === reportType);
      if (category && category.reports.length > 0) {
        console.log(`Setting default report for ${reportType} category`);
        const defaultReport = {
          ...category.reports[0],
          categoryId: category.id,
          _timestamp: Date.now()
        };
        setSelectedReport(defaultReport);
      }
    }
    return () => {
      delete window.setSelectedReport;
    };
  }, [currentView]);
  const handleSaveRequisition = (requisition, isDraft = true) => {
    const newRequisition = {
      id: `REQ-2023-00${requisitions.length + 1}`,
      name: requisition.name || 'Unnamed Requisition',
      vendor: requisition.vendor || 'Not Specified',
      status: isDraft ? 'Draft' : 'Pending Approval',
      date: new Date().toISOString().split('T')[0],
      total: requisition.total || 0
    };
    setRequisitions([...requisitions, newRequisition]);
    setCurrentView('dashboard');
  };
  const handleSavePurchaseOrder = (purchaseOrder, fromRequisition = null) => {
    const newPurchaseOrder = {
      id: `PO-2023-00${purchaseOrders.length + 1}`,
      name: purchaseOrder.name || 'Unnamed Purchase Order',
      vendor: purchaseOrder.vendor || 'Not Specified',
      status: 'Draft',
      date: new Date().toISOString().split('T')[0],
      total: purchaseOrder.total || 0,
      requisitionId: fromRequisition ? fromRequisition.id : null
    };
    setPurchaseOrders([...purchaseOrders, newPurchaseOrder]);
    if (fromRequisition) {
      setRequisitions(requisitions.map(req => req.id === fromRequisition.id ? {
        ...req,
        status: 'Converted to PO'
      } : req));
    }
    setCurrentView('purchase-orders');
  };
  const handleApproveRequisition = requisitionId => {
    setRequisitions(requisitions.map(req => req.id === requisitionId ? {
      ...req,
      status: 'Approved'
    } : req));
  };
  const handleConvertToPO = requisition => {
    setSelectedRequisition(requisition);
    setCurrentView('create-po-from-req');
  };
  const handleAutoConvertToPO = requisitionId => {
    const requisition = requisitions.find(req => req.id === requisitionId);
    if (requisition) {
      handleSavePurchaseOrder(requisition, requisition);
    }
  };
  const handleLocaleChange = e => {
    setLocale(e.target.value);
    setProfileMenuOpen(false);
  };
  const toggleProfileMenu = () => {
    setProfileMenuOpen(!profileMenuOpen);
  };
  const handleLogin = () => {
    setIsAuthenticated(true);
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
    setProfileMenuOpen(false);
  };
  const refreshReport = () => {
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 800);
  };
  const renderLoadingState = () => <div className="flex items-center justify-center h-64" data-id="element-0">
      <div className="text-center" data-id="element-1">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500 mx-auto" data-id="element-2"></div>
        <p className="mt-3 text-sm text-gray-500" data-id="element-3">Loading report data...</p>
      </div>
    </div>;
  if (!isAuthenticated) {
    return <AuthScreen onLogin={handleLogin} data-id="element-4" />;
  }
  return <div className="min-h-screen bg-gray-50" data-id="element-5">
      <header className="bg-white shadow" data-id="element-6">
        <div className="w-[85%] mx-auto px-4 py-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-7">
          <div className="flex items-center" data-id="element-8">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6TfLnmLX2evxxxZK6TYFtj/Rapid_P2P_-_Blue-Green.svg" alt="RapidP2P Logo" className="h-10" data-id="element-9" />
          </div>
          <div className="flex items-center space-x-4" data-id="element-10">
            <div className="relative" data-id="element-11">
              <button ref={profileButtonRef} onClick={toggleProfileMenu} className="flex items-center space-x-2 focus:outline-none" data-id="element-12">
                <div className="h-8 w-8 rounded-full overflow-hidden flex items-center justify-center bg-indigo-600 text-white text-sm" data-id="element-13">
                  <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Profile" className="h-full w-full object-cover" onError={e => {
                  e.currentTarget.style.display = 'none';
                  e.currentTarget.parentElement.textContent = 'A';
                }} data-id="element-14" />
                </div>
                <span className="text-sm text-gray-500" data-id="element-15">Admin</span>
                <ChevronDownIcon className="h-4 w-4 text-gray-500" data-id="element-16" />
              </button>
              {profileMenuOpen && <div ref={profileMenuRef} className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 ring-1 ring-black ring-opacity-5" data-id="element-17">
                  <div className="px-4 py-2 text-xs text-gray-500 border-b border-gray-100" data-id="element-18">
                    admin@example.com
                  </div>
                  <div className="px-4 py-2 border-b border-gray-100" data-id="element-19">
                    <label className="block text-xs font-medium text-gray-500 mb-1" data-id="element-20">
                      Locale
                    </label>
                    <select value={locale} onChange={handleLocaleChange} className="block w-full pl-3 pr-10 py-1 text-sm border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 rounded-md" data-id="element-21">
                      {getAvailableLocales().map(localeOption => <option key={localeOption.code} value={localeOption.code} data-id="element-22">
                          {localeOption.name}
                        </option>)}
                    </select>
                  </div>
                  <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" data-id="element-23">
                    <UserIcon className="h-4 w-4 mr-2 text-gray-500" data-id="element-24" />
                    Profile Settings
                  </a>
                  <button onClick={handleLogout} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center" data-id="element-25">
                    <LogOutIcon className="h-4 w-4 mr-2 text-gray-500" data-id="element-26" />
                    Sign Out
                  </button>
                </div>}
            </div>
          </div>
        </div>
      </header>
      <Navigation currentView={currentView} setCurrentView={setCurrentView} data-id="element-27" />
      <div className="w-[85%] mx-auto" data-id="element-28">
        <Breadcrumbs items={getBreadcrumbs()} currentView={currentView} setCurrentView={setCurrentView} data-id="element-29" />
      </div>
      <main className="w-[85%] mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-30">
        {currentView === 'dashboard' && <Dashboard requisitions={requisitions} purchaseOrders={purchaseOrders} setCurrentView={setCurrentView} locale={locale} data-id="element-31" />}
        {currentView === 'create-requisition' && <>
            <div className="mb-8" data-id="element-32">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-33">
                Create Requisition
              </h2>
              <p className="mt-1 text-sm text-gray-500" data-id="element-34">
                Fill in the details below to create a new purchase requisition
              </p>
            </div>
            <RequisitionForm onSave={handleSaveRequisition} locale={locale} data-id="element-35" />
          </>}
        {currentView === 'create-po' && <>
            <div className="mb-8" data-id="element-36">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-37">
                Create Purchase Order
              </h2>
              <p className="mt-1 text-sm text-gray-500" data-id="element-38">
                Fill in the details below to create a new purchase order
                directly
              </p>
            </div>
            <PurchaseOrderForm onSave={handleSavePurchaseOrder} locale={locale} data-id="element-39" />
          </>}
        {currentView === 'create-po-from-req' && selectedRequisition && <>
            <div className="mb-8" data-id="element-40">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-41">
                Convert Requisition to Purchase Order
              </h2>
              <p className="mt-1 text-sm text-gray-500" data-id="element-42">
                Review and modify details before creating the purchase order
              </p>
            </div>
            <PurchaseOrderForm initialData={selectedRequisition} onSave={data => handleSavePurchaseOrder(data, selectedRequisition)} isConversion={true} locale={locale} data-id="element-43" />
          </>}
        {currentView === 'requisitions' && <>
            <div className="mb-8" data-id="element-44">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-45">Requisitions</h2>
              <p className="mt-1 text-sm text-gray-500" data-id="element-46">
                View and manage all requisitions
              </p>
            </div>
            <div className="bg-white shadow overflow-hidden sm:rounded-md" data-id="element-47">
              <RequisitionList requisitions={requisitions} onApprove={handleApproveRequisition} onConvertToPO={handleConvertToPO} onAutoConvert={handleAutoConvertToPO} locale={locale} data-id="element-48" />
            </div>
          </>}
        {currentView === 'purchase-orders' && <>
            <div className="mb-8 flex justify-between items-center" data-id="element-49">
              <div data-id="element-50">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-51">
                  Purchase Orders
                </h2>
                <p className="mt-1 text-sm text-gray-500" data-id="element-52">
                  View and manage all purchase orders
                </p>
              </div>
              <div className="flex space-x-2" data-id="element-53">
                <button onClick={() => setCurrentView('receipt-list')} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-54">
                  <TruckIcon className="h-4 w-4 mr-1" data-id="element-55" />
                  View Receipts
                </button>
                <button onClick={() => setCurrentView('create-po')} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-56">
                  Create Purchase Order
                </button>
              </div>
            </div>
            <div className="bg-white shadow overflow-hidden sm:rounded-md" data-id="element-57">
              <PurchaseOrderList purchaseOrders={purchaseOrders} locale={locale} onCreateReceipt={poId => {
            const selectedPO = purchaseOrders.find(po => po.id === poId);
            setSelectedPOForReceipt(selectedPO);
            setCurrentView('receipt-list');
          }} data-id="element-58" />
            </div>
          </>}
        {currentView === 'receipt-list' && <>
            <div className="mb-8 flex justify-between items-center" data-id="element-59">
              <div data-id="element-60">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-61">
                  Goods Receipts
                </h2>
                <p className="mt-1 text-sm text-gray-500" data-id="element-62">
                  View and manage all goods receipts
                </p>
              </div>
            </div>
            <ReceiptList locale={locale} onCreateReceipt={() => {
          setSelectedPOForReceipt(null);
          // Navigate to receipting view to create a new receipt
          setCurrentView('receipting');
        }} onViewReceiptDetails={receipt => {
          setSelectedReceipt(receipt);
        }} data-id="element-63" />
          </>}
        {currentView === 'receipting' && <ReceiptingView poId={selectedPOForReceipt?.id} initialPO={selectedPOForReceipt} onBack={() => setCurrentView(selectedPOForReceipt ? 'purchase-orders' : 'receipt-list')} locale={locale} data-id="element-64" />}
        {currentView === 'vendor-management' && <VendorManagement locale={locale} currentView={currentView} data-id="element-65" />}
        {currentView === 'vendors' && <VendorManagement locale={locale} currentView={currentView} data-id="element-66" />}
        {currentView === 'onboard-vendor' && <VendorManagement locale={locale} currentView={currentView} data-id="element-67" />}
        {currentView === 'vendor-details' && <VendorManagement locale={locale} currentView={currentView} data-id="element-68" />}
        {currentView === 'compliance-check' && <VendorManagement locale={locale} currentView={currentView} data-id="element-69" />}
        {(currentView === 'ap-management' || currentView === 'invoice-entry' || currentView === 'invoice-list' || currentView === 'matching' || currentView === 'statement-reconciliation' || currentView === 'ap-dashboard') && <APManagement locale={locale} currentView={currentView} data-id="element-70" />}
        {(currentView === 'rcti-list' || currentView === 'rcti-entry' || currentView === 'rcti-details') && <RCTIManagement locale={locale} currentView={currentView} setCurrentView={setCurrentView} data-id="element-71" />}
        {currentView === 'rcti-management' && <RCTIManagement locale={locale} currentView={currentView} setCurrentView={setCurrentView} data-id="element-72" />}
        {currentView === 'settings' && <EntityManagement locale={locale} data-id="element-73" />}
        {currentView === 'users' && <UserManagement locale={locale} data-id="element-74" />}
        {currentView === 'license-manager' && <LicenseManager locale={locale} data-id="element-75" />}
        {currentView === 'countries' && <CountriesManagement locale={locale} data-id="element-76" />}
        {currentView === 'currency' && <CurrencyManagement locale={locale} data-id="element-77" />}
        {currentView === 'email-configuration' && <EmailConfiguration locale={locale} data-id="element-78" />}
        {currentView === 'chart-of-accounts' && <ChartOfAccounts locale={locale} data-id="element-79" />}
        {currentView === 'ledger' && <LedgerView locale={locale} data-id="element-80" />}
        {currentView === 'payments' && <PaymentsView locale={locale} data-id="element-81" />}
        {currentView === 'currency-exchange' && <CurrencyExchangeView locale={locale} data-id="element-82" />}
        {currentView === 'delegations' && <DelegationsManager locale={locale} data-id="element-83" />}
        {currentView === 'rules-workflows' && <RulesWorkflowManager locale={locale} data-id="element-84" />}
        {currentView === 'procurement-dashboard' && <ProcurementDashboard requisitions={requisitions} purchaseOrders={purchaseOrders} setCurrentView={setCurrentView} locale={locale} data-id="element-85" />}
        {currentView === 'catalogs' && <CatalogsManagement locale={locale} data-id="element-86" />}
        {currentView === 'budget' && <BudgetManagement locale={locale} data-id="element-87" />}
        {currentView === 'tax-codes' && <TaxCodesManagement locale={locale} data-id="element-88" />}
        {currentView === 'rounding' && <RoundingConfiguration locale={locale} data-id="element-89" />}
        {currentView === 'tolerance' && <ToleranceConfiguration locale={locale} data-id="element-90" />}
        {currentView === 'tags' && <TagsManagement locale={locale} data-id="element-91" />}
        {currentView === 'notes' && <NotesManagement locale={locale} data-id="element-92" />}
        {currentView === 'audit' && <AuditManagement locale={locale} data-id="element-93" />}
        {currentView === 'reports' && <ReportsOverview setCurrentView={setCurrentView} setSelectedReport={setSelectedReport} locale={locale} data-id="element-94" />}
        {currentView === 'reports-construction' && selectedReport && <div className="construction-report-container" data-id="element-95">
            <div className="mb-6 flex items-center justify-between" data-id="element-96">
              <div data-id="element-97">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-98">
                  Construction Payment Report
                </h2>
                <p className="mt-1 text-sm text-gray-500" data-id="element-99">
                  {selectedReport.description}
                </p>
              </div>
              <div className="flex space-x-2" data-id="element-100">
                <button onClick={refreshReport} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-101">
                  <RefreshCwIcon className="h-4 w-4 mr-1" data-id="element-102" />
                  Refresh
                </button>
                <button onClick={() => {
              setSelectedReport(null);
              setCurrentView('reports');
            }} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-103">
                  <ChevronLeftIcon className="h-4 w-4 mr-1" data-id="element-104" />
                  Back to Reports
                </button>
              </div>
            </div>
            {isLoading ? renderLoadingState() : <ConstructionPaymentReport filters={{
          dateRange: 'last30days',
          startDate: new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
          endDate: new Date().toISOString().split('T')[0]
        }} locale={locale} data-id="element-105" />}
          </div>}
        {currentView === 'reports-operational' && selectedReport && <div className="operational-report-container" data-id="element-106">
            <div className="mb-6 flex items-center justify-between" data-id="element-107">
              <div data-id="element-108">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-109">
                  Operational Analytics Report
                </h2>
                <p className="mt-1 text-sm text-gray-500" data-id="element-110">
                  {selectedReport.description}
                </p>
              </div>
              <button onClick={() => {
            setSelectedReport(null);
            setCurrentView('reports');
          }} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-111">
                <ChevronLeftIcon className="h-4 w-4 mr-1" data-id="element-112" />
                Back to Reports
              </button>
            </div>
            {isLoading ? renderLoadingState() : <OperationalAnalyticsReport filters={{
          dateRange: 'last30days',
          startDate: new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
          endDate: new Date().toISOString().split('T')[0]
        }} locale={locale} report={selectedReport} data-id="element-113" />}
          </div>}
        {currentView === 'reports-ap' && selectedReport && <div className="ap-report-container" data-id="element-114">
            <div className="mb-6 flex items-center justify-between" data-id="element-115">
              <div data-id="element-116">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-117">
                  {selectedReport.id === 'invoice-aging' ? 'Invoice Aging Report' : 'Invoice Payment Status Report'}
                </h2>
                <p className="mt-1 text-sm text-gray-500" data-id="element-118">
                  {selectedReport.description}
                </p>
              </div>
              <button onClick={() => {
            setSelectedReport(null);
            setCurrentView('reports');
          }} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-119">
                <ChevronLeftIcon className="h-4 w-4 mr-1" data-id="element-120" />
                Back to Reports
              </button>
            </div>
            {isLoading ? renderLoadingState() : selectedReport.id === 'invoice-aging' ? <InvoiceAgingReport filters={{
          dateRange: 'last30days',
          startDate: new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
          endDate: new Date().toISOString().split('T')[0]
        }} locale={locale} data-id="element-121" /> : <InvoicePaymentStatusReport filters={{
          dateRange: 'last30days',
          startDate: new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
          endDate: new Date().toISOString().split('T')[0]
        }} locale={locale} data-id="element-122" />}
          </div>}
        {currentView === 'reports-procurement' && selectedReport && <div className="procurement-report-container" data-id="element-123">
            <div className="mb-6 flex items-center justify-between" data-id="element-124">
              <div data-id="element-125">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-126">
                  Purchase Order Summary Report
                </h2>
                <p className="mt-1 text-sm text-gray-500" data-id="element-127">
                  {selectedReport.description}
                </p>
              </div>
              <button onClick={() => {
            setSelectedReport(null);
            setCurrentView('reports');
          }} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-128">
                <ChevronLeftIcon className="h-4 w-4 mr-1" data-id="element-129" />
                Back to Reports
              </button>
            </div>
            {isLoading ? renderLoadingState() : <PurchaseOrderSummary filters={{
          dateRange: 'last30days',
          startDate: new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
          endDate: new Date().toISOString().split('T')[0]
        }} locale={locale} data-id="element-130" />}
          </div>}
        {currentView === 'reports-financial' && selectedReport && <div className="financial-report-container" data-id="element-131">
            <div className="mb-6 flex items-center justify-between" data-id="element-132">
              <div data-id="element-133">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-134">
                  Budget vs Actual Report
                </h2>
                <p className="mt-1 text-sm text-gray-500" data-id="element-135">
                  {selectedReport.description}
                </p>
              </div>
              <button onClick={() => {
            setSelectedReport(null);
            setCurrentView('reports');
          }} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-136">
                <ChevronLeftIcon className="h-4 w-4 mr-1" data-id="element-137" />
                Back to Reports
              </button>
            </div>
            {isLoading ? renderLoadingState() : <BudgetVsActualReport filters={{
          dateRange: 'last30days',
          startDate: new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
          endDate: new Date().toISOString().split('T')[0]
        }} locale={locale} data-id="element-138" />}
          </div>}
        {currentView === 'reports-requisition' && selectedReport && <div className="requisition-report-container" data-id="element-139">
            <div className="mb-6 flex items-center justify-between" data-id="element-140">
              <div data-id="element-141">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-142">
                  Requisition Summary Report
                </h2>
                <p className="mt-1 text-sm text-gray-500" data-id="element-143">
                  {selectedReport.description}
                </p>
              </div>
              <button onClick={() => {
            setSelectedReport(null);
            setCurrentView('reports');
          }} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-144">
                <ChevronLeftIcon className="h-4 w-4 mr-1" data-id="element-145" />
                Back to Reports
              </button>
            </div>
            {isLoading ? renderLoadingState() : <RequisitionSummaryReport filters={{
          dateRange: 'last30days',
          startDate: new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
          endDate: new Date().toISOString().split('T')[0]
        }} locale={locale} data-id="element-146" />}
          </div>}
        {currentView === 'decimal-precision' && <DecimalPrecisionConfiguration locale={locale} data-id="element-147" />}
        {currentView === 'di-validation' && <DIValidation locale={locale} data-id="element-148" />}
        {currentView === 'di-exceptions' && <DIExceptionHandling locale={locale} data-id="element-149" />}
        {currentView === 'di-training' && <DITraining locale={locale} data-id="element-150" />}
        {currentView === 'document-library' && <DocumentLibrary locale={locale} data-id="element-151" />}
        {currentView === 'file-library' && <FileLibrary locale={locale} data-id="element-152" />}
        {currentView === 'tasks' && <TasksManagement locale={locale} data-id="element-153" />}
        {currentView === 'messages' && <MessagesManagement locale={locale} data-id="element-154" />}
        {currentView === 'notifications' && <NotificationsManagement locale={locale} data-id="element-155" />}
        {isExpenseView && <ExpenseManagement locale={locale} currentView={currentView} data-id="element-156" />}
        {isContractView && <ContractManagement locale={locale} currentView={currentView} data-id="element-157" />}
        {isCreditNoteView && <CreditNoteManagement locale={locale} currentView={currentView} data-id="element-158" />}
        {currentView === 'communications' && <CommunicationsView locale={locale} data-id="element-159" />}
        {currentView === 'status-management' && <StatusManagement locale={locale} data-id="element-160" />}
        {currentView === 'rules' && <RulesManager locale={locale} data-id="element-161" />}
        {currentView === 'workflows' && <WorkflowManager locale={locale} data-id="element-162" />}
      </main>
    </div>;
}